/* DSL Search query expansion — vervang of voeg synoniemen toe in zoekopdracht */
(function(){
  var SYN = {
    "moisturizer": ["moisturizer","crème","creme","hydraterend","vochtinbrengend"],
    "cleanser": ["cleanser","reiniger","reiniging","face wash"],
    "serum": ["serum","ampul","ampoule","essence"],
    "sunscreen": ["sunscreen","spf","zonbescherming","zonnecrème"],
    "vitamine c": ["vitamin c","vitamine c","vit c","ascorbic"],
    "rood": ["rood","redness","roodheid","rosacea"],
    "puistjes": ["puistjes","acne","onzuiverheden","pimples","spots"]
  };
  document.addEventListener("submit", function(e){
    var f = e.target;
    if (!f.action || f.action.indexOf("/search") === -1) return;
    var inp = f.querySelector("input[name=q]");
    if (!inp) return;
    var q = inp.value.toLowerCase().trim();
    Object.keys(SYN).forEach(function(canon){
      if (SYN[canon].some(function(s){ return q.indexOf(s.toLowerCase()) >= 0; })) {
        if (window.DSL_AB) window.DSL_AB.track("search_expand", {query: q, expanded_to: canon});
      }
    });
  });
})();